import dayjs, { ConfigType } from 'dayjs';
import { format, parseISO } from 'date-fns';
import { enUS } from 'date-fns/locale';

export const US_DATE_FORMAT = 'MM/DD/YYYY';

export const dateToString = (date?: ConfigType, format = US_DATE_FORMAT): string => {
  const formattedDate = dayjs(date).format(format);
  // TODO: This date should not be null
  return formattedDate !== 'Invalid Date' ? formattedDate : '';
};

export const versionDate = (date: string) => {
  const formattedDate = new Intl.DateTimeFormat('en-US', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(date));
  return formattedDate;
};

export const getDocumentDate = (date: string) => {
  const parsedDate = parseISO(date);
  return format(parsedDate, 'E MMM dd yyyy', { locale: enUS });
};
